import React from 'react';
import Sym from './Sym';

/**
 * Pestañas en píldora (el patrón de Analytics: Empresas / Empleados / SAT / Export).
 *
 * @param {Array<{id:string,label:string,icon?:string}>} items
 * @param {string} value   id de la pestaña activa
 * @param {Function} onChange (id) => void
 */
export const Tabs = ({ items = [], value, onChange, className = '', style }) => (
  <div className={['a2-tabs', className].filter(Boolean).join(' ')} style={style} role="tablist">
    {items.map((t) => (
      <button
        key={t.id}
        role="tab"
        aria-selected={value === t.id}
        className={['a2-tab', value === t.id ? 'is-active' : ''].filter(Boolean).join(' ')}
        onClick={() => onChange?.(t.id)}
        type="button"
      >
        {t.icon ? <Sym name={t.icon} size={18} /> : null}
        {t.label}
      </button>
    ))}
  </div>
);

/** Pestañas subrayadas (el patrón de Mi cuenta: Datos / Seguridad / Preferencias). */
export const TabsUnderline = ({ items = [], value, onChange, className = '', style }) => (
  <div
    className={['a2-tabs-underline', className].filter(Boolean).join(' ')}
    style={style}
    role="tablist"
  >
    {items.map((t) => (
      <button
        key={t.id}
        role="tab"
        aria-selected={value === t.id}
        className={['a2-tab-underline', value === t.id ? 'is-active' : ''].filter(Boolean).join(' ')}
        onClick={() => onChange?.(t.id)}
        type="button"
      >
        {t.label}
      </button>
    ))}
  </div>
);

/**
 * Control segmentado (el selector de tema claro/auto/oscuro y los filtros
 * cortos de estado).
 *
 * Si el elemento trae `text: true` la etiqueta se pinta a la vista y el botón
 * crece con el contenido; si no, queda el botón cuadrado de solo icono y la
 * etiqueta viaja en el title/aria-label.
 *
 * @param {Array<{id:string,icon?:string,label:string,text?:boolean}>} items
 */
export const SegmentedControl = ({ items = [], value, onChange, className = '', style, ...rest }) => (
  <div className={['a2-seg', className].filter(Boolean).join(' ')} style={style} {...rest}>
    {items.map((s) => (
      <button
        key={s.id}
        type="button"
        title={s.label}
        aria-label={s.text ? undefined : s.label}
        aria-pressed={value === s.id}
        className={[
          'a2-seg-btn',
          s.text ? 'a2-seg-btn--text' : '',
          value === s.id ? 'is-active' : '',
        ].filter(Boolean).join(' ')}
        onClick={() => onChange?.(s.id)}
      >
        {s.icon ? <Sym name={s.icon} size={18} /> : null}
        {s.text ? s.label : null}
      </button>
    ))}
  </div>
);

export default Tabs;
